// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"InputSearch_inputSearch__Vbo6J","iconSearch":"InputSearch_iconSearch__3x_b0"};